export const sanitizeConfigValue = (value) => {
  if (value == null) return undefined;

  const cleaned = String(value)
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .trim();

  return cleaned || undefined;
};
